<template>
  <div>
    <vxe-column
      sortable
      v-for="d in customCol"
      :filters="[{ data: '' }]"
      :filter-method="$$filterHeaderTable"
      width="150"
      align="center"
      :field="d.key"
      :key="d.key"
      :title="d.title"
      :formatter="
        d.format == 'number'
          ? $$formatNumber
          : d.format == 'price'
          ? $$formatAmountBc
          : d.format == 'date'
          ? $$formatDate
          : d.format == 'datetime'
          ? $$formatDatetimemoment
          : ''
      "
    >
    </vxe-column>
  </div>
</template>
<script>
export default {
  data() {
    return {
      customCol: [],
    };
  },
  mounted() {
    const customHead = this.$store.state.customHead;
    let customCols = [];
    for (const key in customHead) {
      if (customHead[key] && customHead[key] != "") {
        let type; // type
        if (key.search("date") !== -1) {
          type = "date";
        } else if (key.search("number") !== -1) {
          type = "price";
        } else {
          type = "";
        }
        customCols.push({
          key: key,
          title: customHead[key],
          format: type,
        });
      }
    }
    this.customCol = customCols;
  },
};
</script>
